<template>
  <div>
    <div class="page-content border-bottom">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="searchInfo" class="demo-form-inline">
          <el-form-item label="会员姓名">
            <el-input v-model="searchInfo.memRealName" placeholder="请输入会员姓名" class="form-item-width" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchInfo.memTel" placeholder="请输入会员手机号" class="form-item-width" clearable></el-input>
          </el-form-item>
          <el-form-item class="right-btns">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="onReset">重置</el-button>
            <el-button type="primary" @click="onAddUser">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格展示区域 -->
    <div class="page-content margin-top">
      <!-- 表格组件 -->
      <el-table :data="tableData" stripe style="width: 100%"  border
        :header-cell-style="{ background: '#eef1f6', color: '#606266','text-align':'center' }"
        :cell-style="{'text-align':'center'}"  height="66vh" scroll-y
      >
        <!-- 循环展示表格 -->
        <el-table-column v-for="tab in tableTitle" :key="tab.code" :label="tab.name" show-overflow-tooltip
          :width="tab.width" >
          <template slot-scope="scope">
            <span v-if="tab.code === 'memSex'">
              {{ scope.row[tab.code] === 0 ? '男' : '女' }}
            </span>
            <span v-else>
              {{ scope.row[tab.code] }}
            </span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <span @click="consumeRow(scope.row)" class="consume-btn">核销</span>
            <span @click="updateRow(scope.row)" class="update-btn">修改</span>
            <el-popconfirm :title="`确定删除${scope.row.memRealName}吗？`" @confirm="deleteRow(scope.row)"
              icon="el-icon-delete" icon-color="skyblue">
              <span slot="reference" class="delete-btn">删除</span>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination :total="dataTotal" :page="searchInfo.page" :limit="searchInfo.limit" @pagination="onChangePages" />
      </div>
    </div>

    <!-- 新增弹框 -->
    <el-dialog :title="isUpdate ? '修改' : '新增'" :visible.sync="dialogVisible" top="5vh" width="672px">
      <el-form ref="form" class="dialog-form" :model="accountEdit" :rules="rules" label-width="110px">
        <el-form-item label="会员姓名" prop="memRealName">
          <el-input v-model="accountEdit.memRealName" placeholder="请输入会员姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="memSex">
          <el-select v-model="accountEdit.memSex" placeholder="请选择性别" class="form-item-width">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="memTel">
          <el-input v-model="accountEdit.memTel" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="车牌号" prop="carNo">
          <el-input v-model="accountEdit.carNo" placeholder="请输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="生日" prop="memBirthday">
          <el-date-picker
              v-model="accountEdit.memBirthday"
              type="date"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              class="form-item-width"
              clearable
            >
            </el-date-picker>
        </el-form-item>
        <el-form-item label="总积分" prop="memPoints">
          <el-input v-model="accountEdit.memPoints" placeholder="请输入总积分"></el-input>
        </el-form-item>
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmitDialog()">确定</el-button>
      </span>
    </el-dialog>

    <!-- 核销弹框 -->
    <el-dialog title='核销' :visible.sync="consumeDialog" top="5vh" width="672px">
      <el-form ref="form" class="dialog-form" :model="consume" :rules="consumeRules" label-width="110px">
        <el-form-item label="会员姓名" prop="memRealName">
          <el-input v-model="consume.memRealName" placeholder="请输入会员姓名" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="memTel">
          <el-input v-model="consume.memTel" placeholder="请输入手机号" disabled></el-input>
        </el-form-item>
        <el-form-item label="总积分" prop="memPoints">
          <el-input v-model="consume.memPoints" placeholder="请输入总积分" disabled></el-input>
        </el-form-item>
        <el-form-item label="核销积分" prop="consumePoints">
          <el-input v-model="consume.consumePoints" type="number" placeholder="请输入核销积分"></el-input>
        </el-form-item>
        <el-form-item label="礼品名称" prop="giftName">
          <el-input v-model="consume.giftName" placeholder="请输入礼品名称" ></el-input>
        </el-form-item>
        <el-form-item label="礼品价值" prop="giftCost">
          <el-input v-model="consume.giftCost" placeholder="请输入礼品价值" ></el-input>
        </el-form-item>
        <el-form-item label="兑换凭证" prop="voucherPic">
          <el-upload
            action="#" 
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :limit="1"
            :http-request="uploadSuccess"
            :multiple="false"
            ref="upload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogUpload">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="consume.remark" placeholder="请输入备注" ></el-input>
        </el-form-item>
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="consumeDialog = false">取消</el-button>
        <el-button type="primary" @click="consumeSubmit()">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getMember, getAddMember, getDeleteMember ,getConsumeMember} from '@/api/member.js'
import { uploadImage,deleteImage} from '../../api/uploadFile'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      // 查询数据
      searchInfo: {
        memRealName: '',
        memTel:'',
        page: 1,
        size: 20,
      },
      // 新增弹框表单信息
      accountEdit: {
        memRealName: '',
        memSex:'',
        memTel:'',
        carNo:'',
        memBirthday:'',
        memPoints:'',
      },
      //核销弹框
      consume:{
        memRealName:'',
        memTel:'',
        memPoints:'',
        consumePoints: 0,
        remark:'',
        giftName:'',
        giftCost:'',
        imageUrl: '', // 用于存储服务器返回的图片URL
        id:''
      },
      fileList: [],
      dialogImageUrl:'',
      dialogUpload:false,

      options: [{
          value: 0,
          label: '男'
        }, {
          value: 1,
          label: '女'
        }
      ],
      
      // 表格数据
      tableData: [],
      // 数据总数
      dataTotal: 0,
      // 标记是否新增
      isUpdate: false,
      // 是否展示弹框
      dialogVisible: false,
      consumeDialog: false,

      // 表格标题数组
      tableTitle: [
        { name: '会员姓名', code: 'memRealName', width: '' },
        { name: '性别', code: 'memSex', width: '' },     
        { name: '手机号', code: 'memTel', width: '' },
        { name: '车牌号', code: 'carNo', width: '' },  
        { name: '生日', code: 'memBirthday', width: '' },       
        { name: '总积分', code: 'memPoints', width: '' },
      ],
      //表单校验规则对象
      rules: {
        memRealName: [
          { required: true, message: '请输入会员姓名', trigger: 'blur' }
        ],
        memSex: [
          { required: true, message: '请输入性别', trigger: 'blur' }
        ],
        memTel: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        carNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ],
        memBirthday: [
          { required: true, message: '请选择生日日期', trigger: 'blur' }
        ],
        memPoints: [
          { required: true, message: '请输入总积分', trigger: 'blur' }
        ],
      },
      consumeRules:{
        memRealName: [
          { required: true, message: '请输入会员姓名', trigger: 'blur' }
        ],
        memTel: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        memPoints: [
          { required: true, message: '请输入总积分', trigger: 'blur' }
        ],
        consumePoints: [
          { required: true, message: '请输入核销积分', trigger: 'blur' }
        ],
        giftName: [
          { required: true, message: '请输入兑换礼品名称', trigger: 'blur' }
        ],
        giftCost: [
          { required: true, message: '请输入兑换礼品价值', trigger: 'blur' }
        ],
        
      }
    }
  },
  mounted() {
    // 获取列表数据
    this.onSearch()
  },
  methods: {
    // 查询按钮
    onSearch() {
      this.searchInfo.page = 1
      this.onGetDataList()
    },
    // 获取列表
    async onGetDataList() {
      // 分类接口
      const data = await getMember(this.searchInfo)
      this.tableData = data.data.records
      this.dataTotal = data.data.total
    },
    // 重置按钮
    onReset() {
      this.searchInfo.memRealName = '',
      this.searchInfo.memTel = '',
      this.onSearch()
    },

    // 新增按钮
    onAddUser() {
      this.isUpdate = false
      this.dialogVisible = true
      this.accountEdit = {
        id:0,
        memRealName: '',
        memSex:'',
        memTel:'',
        carNo:'',
        memBirthday:'',
        memPoints:'',
      } 
      //清空校验规则错误提示信息
      this.$nextTick(()=>{
        this.$refs.form.clearValidate()
      })
    },
    // 修改按钮
    updateRow(row) {
      this.isUpdate = true
      this.dialogVisible = true 
      //清空校验规则错误提示信息
      this.$nextTick(()=>{
        this.$refs.form.clearValidate()
      })
      this.accountEdit = {
        memRealName: row.memRealName,
        memSex: row.memSex,
        memTel: row.memTel,
        carNo: row.carNo,
        memBirthday: row.memBirthday,
        memPoints: row.memPoints,
      } 
      Object.assign(this.accountEdit, row)
    },
    //核销按钮
    consumeRow(row) {
      this.consumeDialog = true 
      //清空校验规则错误提示信息
      this.$nextTick(()=>{
        this.$refs.form.clearValidate()
      })
      this.consume.memRealName= row.memRealName,
      this.consume.memTel= row.memTel,
      this.consume.memPoints= row.memPoints
      this.consume.id= row.id
      this.consume.consumePoints = '',
      this.consume.giftName = '',
      this.consume.giftCost = '',
      this.consume.voucherPic = '',
      this.fileList = []

      // this.consume = {
      //   memRealName: row.memRealName,
      //   memTel: row.memTel,
      //   memPoints: row.memPoints,
      //   consumePoints: row.consumePoints,
      //   remark: row.remark,
      // } 
      // Object.assign(this.consume, row)
    },
    //上传图片
    async handleRemove(file, fileList) {
      console.log(file, fileList)
      await deleteImage(this.accountEdit.awardSourcePic);
      //this.consume.imageUrl = '' // 清空图片URL
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogUpload = true;
    },
    async uploadSuccess(file){
      // let formData = new FormData()
      // formData.append("memId", this.consume.id)
      // formData.append("file", file.file)
      // const data = await getUploadImg(formData)
      // if (data.code == '200') {
      //   this.consume.voucherPic = data.data
      //   this.msgsuccess('上传成功')
      // } 
      try {
        const fileName =await uploadImage(file.file);
        this.consume.voucherPic = fileName
        this.msgsuccess('上传成功')
      } catch (err) {
        this.msgsuccess('上传失败')
      }
    },

    // 删除按钮
    async deleteRow(row) {
      const data = await getDeleteMember(row.id)
      if (data.code == '200') {
        this.msgsuccess('删除成功')
        this.onGetDataList()
      } else {
        this.msgerror('删除失败')
      }

    },
    // 分页方法
    onChangePages(pageInfo) {
      const { page, limit } = pageInfo
      this.searchInfo.page = page
      this.searchInfo.size = limit
      this.onGetDataList()
    },

    // 弹框确认按钮
    onSubmitDialog() {
      //先进行表单验证，验证通过后再发请求
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = await getAddMember(this.accountEdit)
          if (data.code == '200') {
            this.dialogVisible = false
            this.msgsuccess('保存成功')
            this.onGetDataList()
          } else if(data.code == 'F40001') {
            this.dialogVisible = false
            this.msgerror(data.msg)
          }
        } else {
          return false;
        }
      })
    },
    
    consumeSubmit(){
      if(this.consume.voucherPic == ''){
         this.msgerror('请上传兑换凭证！')
          return;
      } 
       //先进行表单验证，验证通过后再发请求
       this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = await getConsumeMember(this.consume)
          if (data.code == '200') {
            this.consumeDialog = false
            this.msgsuccess('保存成功')
            this.onGetDataList()
          } else {
            this.consumeDialog = false
            this.msgerror('保存失败')
          }
        } else {
          return false;
        }
      })
    }
  
  },
}
</script>

<style lang="less" scoped>
.form-item-width {
  width: 100%;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.el-form-item {
  font-weight: bold;
  margin: 0 20px 4px 10px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.examine-btn {
  cursor: pointer;
  color: #409eff;
}

.update-btn {
  cursor: pointer;
  color: #409eff;
  margin: 0px 20px;
}

.consume-btn{
  cursor: pointer;
  color: #1a8704;
}

.delete-btn {
  cursor: pointer;
  color: #f56c6c;
}

.dialog-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>